// Shows the Runeterra world map with an animated dotted-line journey to the
// current region, then proceeds to the region's campaign map.

import type { Scene } from "../engine/scene/SceneManager";
import type { Game } from "../game/Game";
import { getAct } from "../data/acts";
import { MapScene } from "./MapScene";
import { createJourneyMapElement } from "./journeyMapUtil";

export class WorldMapScene implements Scene {
  private root!: HTMLDivElement;

  constructor(private game: Game) {}

  enter(): void {
    const state = this.game.runState!;
    const act = getAct(state.act);
    const isFirstAct = state.act === 1;

    this.root = document.createElement("div");
    this.root.style.cssText =
      "position:absolute;inset:0;display:flex;flex-direction:column;" +
      "align-items:center;justify-content:center;background:#0a0e14;z-index:10;";

    const label = document.createElement("div");
    label.textContent = isFirstAct
      ? "YOUR JOURNEY BEGINS"
      : `YOUR JOURNEY CONTINUES TO ${act.name.toUpperCase()}`;
    label.style.cssText =
      "color:var(--accent);font-size:13px;letter-spacing:2px;" +
      "margin-bottom:16px;text-align:center;";
    this.root.appendChild(label);

    const mapEl = createJourneyMapElement(state.act, state.difficulty);
    this.root.appendChild(mapEl);

    const btn = document.createElement("button");
    btn.className = "btn";
    btn.textContent = `ENTER ${act.name.toUpperCase()}`;
    btn.style.marginTop = "20px";
    btn.addEventListener("click", () => {
      this.game.sceneManager.transition(new MapScene(this.game));
    });
    this.root.appendChild(btn);

    this.game.sceneRoot.appendChild(this.root);
  }

  exit(): void {
    this.root?.remove();
  }

  update(_dt: number): void {}
  render(_ctx: CanvasRenderingContext2D): void {}
}
